import React from 'react'
import {MapContainer, TileLayer, Marker, Popup} from 'react-leaflet'
import {locals} from '../utils/map'
import {attractions} from '../utils/attractions'
import useTitle from '../custom/useTitle'
import useDescription from '../custom/useDescription'

function Map() {
    useTitle("Mappa");
    useDescription("Mappa con tutte le attrazioni ed i percorsi di Ceppo!");
    const {ceppo, morricana} = locals;
    return (
        <div>
            <MapContainer center={morricana} zoom={12} scrollWheelZoom={true} className="full-map">
                <TileLayer 
                    attribution='&copy; <a href="http://osm.org/copyright">OpenStreetMap</a> contributors | <a href="/mappa">vedi mappa completa</a>'
                    url="https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png"/>
                <Marker position={ceppo}>
                    <Popup>
                        Ceppo - Piazzale
                    </Popup>
                </Marker>
                {
                    attractions.map(attr=>{
                        return(
                            <Marker position={attr.coords} key={attr.id}>
                                <Popup >
                                    <img src={attr.icon} alt={attr.title} className="popup-image"/>
                                    <div className="popup-text">{attr.title}</div>
                                </Popup>
                            </Marker>
                        )
                    })
                }

            </MapContainer>
        </div>
    )
}

export default Map
